// @flow
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {actions as CustomersActions} from '../duck';
import Customers from '../components/Customers';
import type {RootState} from '../../index';
import type {Dispatch} from 'redux';

export default connect(
  (state: RootState) => ({
    currency: state.currency.currency,
    country: state.country.country,
    store: state.store.store,
    user: state.auth.user,
    pagination: state.crm.pagination,
    customers: state.crm.customers,
    categories: state.crm.categories,
    isFetchingCustomers: state.crm.isFetchingCustomers,
    isFetchingCategories: state.crm.isFetchingCategories,
    createCategorySuccess: state.crm.createCategorySuccess,
    categoryError: state.crm.categoryError,
    isSaving: state.crm.isSaving,
    editCustomerSuccess: state.crm.editCustomerSuccess,
    customerError: state.crm.customerError,
    fetchCustomersError: state.crm.fetchCustomersError,
    message: state.crm.message,
    isFetchingMessage: state.crm.isFetchingMessage,
    isSavingMessage: state.crm.isSavingMessage,
    saveMessageSuccess: state.crm.saveMessageSuccess,
    editCategorySuccess: state.crm.editCategorySuccess,
    deleteCategorySuccess: state.crm.deleteCategorySuccess,
  }),
  (dispatch: Dispatch<any>) =>
    bindActionCreators({...CustomersActions}, dispatch)
)(Customers);
